import find from 'lodash/find';

import {procedureDetailSource} from 'app/demo/demo_fixtures';
import {tags_list_fixture} from 'app/demo/demo_fixtures/tags_list';
import {
  TaggedItemType,
  TagsDashboardFetchParamsType,
  TagsDashboardLocationParamsType,
} from 'app/tags/types';

import {DEFAULT_PAGE_SIZE} from '../../../utils/constants';

export const TAGS_RTK_TAGS = {
  TAGS: 'Tags',
} as const;

export const useTags = (params) => {
  const {exclude_slug = ''} = params;
  const toExclude = exclude_slug.split(',');

  const filtered_tags = tags_list_fixture.results.filter(
    (tag) => toExclude.indexOf(tag.slug) == -1
  );

  return {
    data: {
      count: filtered_tags.length,
      next: null,
      previous: null,
      results: filtered_tags,
      num_pages: 1,
    },
  };
};
export const useDeleteTag = () => ({});

function addTags(
  args: Array<TaggedItemType> | {documents: Array<TaggedItemType>}
) {
  let taggedItems: Array<TaggedItemType>;

  if (typeof args === 'object' && 'documents' in args) {
    taggedItems = args.documents;
  } else {
    taggedItems = args;
  }
  return {
    unwrap: () => {
      taggedItems.forEach(({name}) => {
        const id = Math.round(Math.random() * 100000);
        const url = `/api/v1/tags/${id}`;

        if (!find(tags_list_fixture.results, (tag) => tag.name === name)) {
          const results = [...tags_list_fixture.results];
          results.push({
            id,
            url,
            name,
            slug: name,
            procedure_count: 1,
            proceduregroup_count: 0,
            policy_count: 0,
          });
          tags_list_fixture.results = results;
        }

        const tags = procedureDetailSource.tags;
        procedureDetailSource.tags = [
          ...tags,
          {
            url,
            name,
            slug: name,
            html_url: `/tags/${id}`,
          },
        ];
      });
      return Promise.resolve(true);
    },
  };
}

export const useBulkAddTags = () => [addTags];
export const useBulkRemoveTags = () => ({});
export const useAddTags = () => [addTags];

export const useRemoveTag = () => {
  function removeTags(url: string) {
    return {
      unwrap: () => {
        const tags = procedureDetailSource.tags.filter((tag) => tag.url != url);
        procedureDetailSource.tags = [...tags];
        return Promise.resolve(true);
      },
    };
  }

  return [removeTags];
};

export const convertLocationParamsToFetchParams = (
  query: TagsDashboardLocationParamsType
): TagsDashboardFetchParamsType => ({
  page: query.page != null ? query.page : '1',
  page_size: query.page_size != null ? query.page_size : `${DEFAULT_PAGE_SIZE}`,
  search: query.search,
  slug: query.slug,
  exclude_slug: query.exclude_slug,
});
